export const STATIC_PAGES_PATH_NAMES: Record<'serp', string> = {
  serp: '/search',
};

export const SOURCE_PLATFORM_QUERY_PARAM_NAME = 'source-platform';
